import React, { useEffect, useState } from "react";

import { formatNumber, matchGeoFirstAndLastCoords, useGetFieldDetails, useGetFieldShape, useTranslation } from "utils";

import { Coordinates, FieldShape } from "models";

import { Card, Divider, Flex, MapStatic, Spin, Tag, Typography } from "components";

type FarmFieldCardProps = {
  fieldId: string;
  dataTestId?: string;
  onClick?: () => void;
};

export const FarmFieldCard = ({ fieldId, dataTestId, onClick = () => {} }: FarmFieldCardProps) => {
  const { t } = useTranslation("modules");
  const { fieldShape } = useGetFieldShape({ fieldId });
  const { data: fieldDetails } = useGetFieldDetails({ id: fieldId });
  const [geometry, setGeometry] = useState<FieldShape>();
  const [location, setLocation] = useState<Coordinates>();

  useEffect(() => {
    if (fieldShape) {
      setGeometry({ ...fieldShape, geometry: matchGeoFirstAndLastCoords(fieldShape.geometry) });
    }
  }, [fieldShape]);

  useEffect(() => {
    if (fieldDetails) {
      setLocation(fieldDetails.location);
    }
  }, [fieldDetails]);

  return (
    <Card dataTestId={dataTestId} className="farm-field-card" mixpanelText="field-card">
      <Flex vertical gap="0.5rem" className="field-details">
        <Flex vertical justify="center">
          <Typography variant="paragraph-m" color="grey-600">
            {!fieldDetails?.reviewed && <Tag text={t("add.fieldCard.missingData")} colour="red" size="large" />}
            {fieldDetails?.number ? t("add.fieldCard.fieldNumber", { fieldNumber: fieldDetails.number }) : t("add.fieldCard.unknownFieldNumber")}
          </Typography>
          <div className="name" onClick={onClick}>
            <Typography variant="h4">{fieldDetails?.name}</Typography>
          </div>
        </Flex>
        <Divider />
        <Flex vertical justify="center">
          <div className="map-container">{!location ? <Spin /> : <MapStatic geometry={geometry} location={location} marker />}</div>
          <div className="size">
            <Typography variant="paragraph-m" color="grey-600">
              {formatNumber({ number: parseFloat(fieldDetails?.size?.toString() || "0") })}ha
            </Typography>
          </div>
        </Flex>
      </Flex>
    </Card>
  );
};
